class Environment {
	static getAppDomain() {
		const hostname = window.location.hostname;
		let appDomain;
		if (hostname.includes('dev')) {
			appDomain = hostname.replace('www', 'app');
		} else {
			appDomain = 'app.nperf.com';
		}
		
		return appDomain;
	}
	
	static getCdnPath() {
		const hostname = window.location.hostname;
		return hostname.replace('www', 'cdn');
	}
}

module.exports = Environment;